import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import { defaultSchema } from "rehype-sanitize";

// Configure sanitization to allow safe HTML tags including media elements
const sanitizeSchema = {
  ...defaultSchema,
  tagNames: [
    ...(defaultSchema.tagNames || []),
    'video',
    'source',
    'img',
  ],
  attributes: {
    ...(defaultSchema.attributes || {}),
    video: ['controls', 'width', 'height', 'src'],
    source: ['src', 'type'],
    img: ['src', 'alt', 'width', 'height'],
  },
};

interface MarkdownWithCursorProps {
  text: string;
}

const MarkdownWithCursor = ({ text }: MarkdownWithCursorProps) => {
  // State to control cursor visibility
  const [cursorVisible, setCursorVisible] = React.useState<boolean>(true);
  
  // Set up blinking effect with useEffect
  React.useEffect(() => {
    // Toggle cursor visibility every 500ms
    const interval = setInterval(() => {
      setCursorVisible(prev => !prev);
    }, 500);
    
    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, []);

  // Add cursor character directly to the text if needed
  const textWithCursor = text + (cursorVisible ? '|' : ' ');

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw, [rehypeSanitize, sanitizeSchema]]}
      components={{
        a: ({ href, children, ...props }: any) => (
          <a href={href} target="_blank" rel="noreferrer" {...props}>{children}</a>
        )
      }}
    >
      {textWithCursor}
    </ReactMarkdown>
  );
};

export default MarkdownWithCursor;
